<template>
    <div class="npcfloat">
        <div v-for="npc in npclist" v-bind:key="npc.npcId">
            <div class="npcdiv" :id="'npc_' + npc.npcId " @click="toggleDiv('npcdesc_' + npc.npcId);">
                <img :alt="'a' + npc.npcName " :title="npc.npcName " :src="ossPath + npc.npcFace">
                <!-- 任务标记：target=任务目标 NPC（去执行），return=待交付 NPC（回任务） -->
                <span v-if="taskMarkMap[npc.npcId]" :class="'taskmark taskmark-' + taskMarkMap[npc.npcId]">{{taskMarkMap[npc.npcId] == 'target' ? '目标' : '任务'}}</span>
                <div :id="'npcdesc_' + npc.npcId " v-show="npcdesc == 'shownpcdesc_' + npc.npcId" class="npcdescdiv" @mouseover="mouseoverDiv('npcdesc_' + npc.npcId)" @mouseout="mouseoutDiv('npcdesc_' + npc.npcId);">
                <div class="npctitle">
                    {{npc.npcName }}
                </div>
                <div class="npcdesc">
                    {{npc.npcDesc }}
                </div>
                <div class="npcbutton">
                    <div id="talktonpc" @click="emitTalk(npc.npcId);">
                    交　谈
                    </div>
                    <div id="asktonpc" @click="emitAsk(npc.npcId);">
                    询　问
                    </div>
                    <div id="applyfromnpc" v-if="(npc.npcCommonTaskStatus==1 || npc.npcSpecialTaskStatus==1) && npc.taskStatus!=1 && canAcceptTask(npc)" @click="emitAccept(npc.npcId);">
                    接任务
                    </div>
                    <div id="completetask" v-if="npc.taskStatus == 1 && !noDeliverNpcIds[npc.npcId]" @click="emitComplete(npc.npcId);">
                    回任务
                    </div>
                    <div id="openpocket" @click="emitGive(npc.npcId);">
                    给道具
                    </div>
                    <div id="refusetask" v-if="npc.taskStatus == 1" @click="emitRefuse(npc.npcId);">
                    推任务
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'npcFloat',
  data() {
    return {
        npcdesc: "",
        isMobile: window.innerWidth <= 768
    };
  },
  computed: {
    ...mapState('street', ['npclist', 'fantasyTaskTodoBOList']),
    ...mapState('user', ['fantasyUserDetail']),
    userLevel: function () {
      return this.fantasyUserDetail.level || 1;
    },
    // 任务标记集合：进行中任务的目标 NPC（去执行）→ target；条件达成任务回发起 NPC 处交付 → return
    taskMarkMap: function() {
      const map = {};
      const list = this.fantasyTaskTodoBOList || [];
      for (let i = 0; i < list.length; i++) {
        const t = list[i];
        if (t.taskStatus == 0) {
          // 进行中：目标 NPC（拜访/送物/寻物/询问对象）
          if (t.taskTo) map[t.taskTo] = 'target';
        } else if (t.taskStatus == 1) {
          // 条件达成：回发起 NPC 处交付
          if (t.taskFrom) map[t.taskFrom] = 'return';
        }
      }
      return map;
    },
    // 给道具类任务（类型 2/3）道具未到手（条件未达成）时，其发布 NPC 隐藏「回任务」
    // （点了也只会报道具不足）；条件达成后按钮恢复，走回任务或给道具均可
    noDeliverNpcIds: function() {
      const ids = {};
      const list = this.fantasyTaskTodoBOList || [];
      for (let i = 0; i < list.length; i++) {
        const t = list[i];
        if ((t.taskType === 2 || t.taskType === 3) && Number(t.taskStatus) !== 1 && t.taskFrom) {
          ids[t.taskFrom] = true;
        }
      }
      return ids;
    }
  },
  mounted: function () {
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    // 接任务按钮可见性：等级范围 + 权重全 0（与后端 weightedTaskType 同口径）——不可接则不显示按钮（后端仍有校验兜底）
    canAcceptTask: function (npc) {
      var level = this.userLevel;
      // NPC 任务等级范围：范围外不显示
      if (npc.taskMinLevel != null && npc.taskMinLevel > 0 && level < npc.taskMinLevel) return false;
      if (npc.taskMaxLevel != null && npc.taskMaxLevel > 0 && level > npc.taskMaxLevel) return false;
      // 权重全 0 配置 = 该 NPC 不发通用委托（拜访任务已全等级可发，新手期圈定由等级范围配置接管）
      // 但若该 NPC 还挂着后台专有任务（npcSpecialTaskStatus=1），按钮仍要显示——权重只决定通用委托
      if (npc.npcSpecialTaskStatus != 1 && npc.taskTypeWeights && npc.taskTypeWeights !== '') {
        var weights = null;
        try { weights = JSON.parse(npc.taskTypeWeights); } catch (e) { weights = null; }
        if (weights) {
          var total = (parseInt(weights.visit, 10) || 0)
            + (parseInt(weights.find, 10) || 0)
            + (parseInt(weights.give, 10) || 0);
          if (total <= 0) return false;
        }
      }
      return true;
    },
    showDiv: function(npcdesc) {
        this.npcdesc = "show" + npcdesc;
    },
    //当鼠标移动到目标div的子元素上时，会触发子元素的mouseoverDiv方法，设置inDiv = true，这样延迟后的判断条件就不成立，从而继续显示了。
    hiddenDiv: function(npcdesc) {
        this.npcdesc = "hidden" + npcdesc;
    },
    // 移动端友好的切换显示
    toggleDiv: function(npcdesc) {
        const key = "show" + npcdesc;
        if (this.npcdesc === key) {
            this.npcdesc = "hidden" + npcdesc;
        } else {
            this.npcdesc = key;
        }
    },
    mouseoverDiv: function(npcdesc) {
        this.npcdesc = "show" + npcdesc;
    },
    mouseoutDiv: function(npcdesc) {
        this.npcdesc = "hidden" + npcdesc;
    },
    emitTalk: function(npcId) {
        this.$emit('talk', npcId);
    },
    emitAsk: function(npcId) {
        this.$emit('ask', npcId);
    },
    emitAccept: function(npcId) {
        this.$emit('accept', npcId);
    },
    emitComplete: function(npcId) {
        this.$emit('complete', npcId);
    },
    emitGive: function(npcId) {
        this.$emit('give', npcId);
    },
    emitRefuse: function(npcId) {
        this.$emit('refuse', npcId);
    },
    // 移动端：点击浮层外部关闭（点击弹窗/交谈框/浮层内部不关闭）
    handleDocumentClick: function(e) {
      if (window.innerWidth > 768) return;
      const el = e.target;
      // 点击弹窗内部时不做任何关闭
      // el-dialog 均 append-to-body（DOM 在 body 下，.pocket/.taskdiv 守卫够不到）
      if (el.closest('.pocket') || el.closest('.taskdiv') || el.closest('.el-dialog')) return;
      // 关闭 NPC 浮层
      if (this.npcdesc !== '') {
        if (el.closest('.npcdescdiv') || el.closest('.npcdiv > img')) return;
        this.npcdesc = '';
      }
    }
  }
}
</script>

<style scoped>
.npcdiv {
	margin:0 10px;
	float:left;
	position: relative;
	cursor: pointer;
}
/* NPC 头像统一尺寸：此前桌面端未限制，立绘按原图渲染会把街道撑成「大图」 */
.npcdiv > img {
	display: block;
	width: 72px;
	height: 72px;
	object-fit: contain;
	border-radius: 6px;
	transition: transform .15s ease, box-shadow .15s ease;
}
.npcdiv:hover > img {
	transform: translateY(-2px) scale(1.06);
	box-shadow: 0 4px 10px rgba(0,0,0,.18);
}
/* 任务标记气泡：target=任务目标（橙），return=待交付（红） */
.npcdiv .taskmark {
	position: absolute;
	top: -8px;
	left: -6px;
	z-index: 95;
	min-width: 34px;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	border-radius: 9px;
	color: #fff;
	font-size: 12px;
	text-align: center;
	box-shadow: 0 1px 3px rgba(0,0,0,.35);
	pointer-events: none;
}
.npcdiv .taskmark-target {
	background-color: #e6a23c;
}
.npcdiv .taskmark-return {
	background-color: #f56c6c;
}
@media (max-width: 768px) {
	.npcdiv .taskmark {
		min-width: 30px;
		height: 16px;
		line-height: 16px;
		font-size: 11px;
	}
}
.npcdescdiv {
	width:200px;height:300px;border:#909090 1px solid;background:#ffd9ee;color:#333;
	word-wrap:break-word;
	filter:progid:DXImageTransform.Microsoft.Shadow(color=#909090,direction=120,strength=5);/*ie*/
	-moz-box-shadow: 5px 5px 5px #909090;/*firefox*/
	-webkit-box-shadow: 5px 5px 5px #909090;/*safari或chrome*/
	box-shadow: 5px 5px 5px #909090;/*opera或ie9*/

	position: absolute;
	top: -50px;
	left: 30px;
	z-index: 90;
	cursor: auto;
}
.npcdiv .npctitle {
	width:100%;
	height:8%;
    background-color:#72b653;
    color:#fff;
	font-weight:bold;
	text-align:center;
	margin:0;
}
.npcdesc {
	width:90%;
	height:40%;
	margin:0 auto;
}
.npcbutton {
	width:100%;
	height:45%;
	margin:auto;
}
.npcbutton div {
    float: left;
	cursor:pointer;
	border:#000 1px solid;
	text-align:center;
	background:#fff3c9;
    padding: 5px 10px;
    margin: 5px 10px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .npcfloat {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;
    padding: 0;
  }
  .npcdiv {
    margin: 0;
    flex: 0 0 auto;
  }
  .npcdiv img {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }
  /* NPC 浮层在移动端改成全屏弹窗风格 */
  .npcdescdiv {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 88vw;
    max-width: 360px;
    height: auto;
    max-height: 70vh;
    overflow-y: auto;
    z-index: 600;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 0 0 9999px rgba(0,0,0,0.5);
    border-radius: 8px;
    padding-bottom: 8px;
  }
  .npcdescdiv .npctitle {
    font-size: 15px;
    padding: 10px 0;
    letter-spacing: 2px;
  }
  .npcdescdiv .npcdesc {
    font-size: 14px;
    line-height: 1.6;
    padding: 8px 12px;
    height: auto;
    min-height: 40px;
  }
  .npcdescdiv .npcbutton {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
    padding: 8px 4px;
    height: auto;
  }
  .npcdescdiv .npcbutton div {
    float: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    padding: 10px 16px;
    margin: 0;
    font-size: 14px;
    border-radius: 4px;
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
